// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1_UX0","cls2":"UserTooltip-cls2_DvO UserTooltip-cls1_UX0"};